module.exports = __webpack_public_path__ + "media/images/sofa-4-6b9713275bbebb99e7ffc75f2e8c4eef.png";